import React from "react";
import { func } from "prop-types";
import {
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

// Strings
import { getMessage } from "CONFIG/i18n";
import { USER_ROLES } from "UTILS/Constants";
import { appEmulationAction } from "CONFIG/ActionFactory";

import ic_call_cut from "ASSETS/Images/ic_call_cut_filled.svg";

import "./AppEmulation.less";
import "COMPONENTS/App/App.less";

class AppEmulationIFrame extends React.Component {
  static propTypes = {
    toggle: func
  };
  constructor(props) {
    super(props);
  }

  // componentDidMount() {
  //   if (this.props.role === USER_ROLES.USER) {
  //     this.props.joinSession();
  //   }
  // }

  componentWillUnmount() {
    appEmulationAction.updateAppEmulationPermissionReply(false);
    appEmulationAction.updateAppEmulationPermissionRequest(false);
  }

  closeClickHandle = () => {
    this.props.toggle(true);
  }

  errorCallBack = error_code => {
    this.setState({errorMessage:error_code})
  }

  postMessageForWindow = () => {
    let iFrameObject = document.getElementById("iframeEmulator");
    if (iFrameObject) {
      let action = (this.props.role === USER_ROLES.AGENT ? "endSession" : "leaveSession");
      iFrameObject.contentWindow.postMessage(action, '*');
    }
    return true;
  }

  render() {
    return (
      <div className="selectDevice1">
        <Modal
          isOpen={this.props.show && this.props.appEmulationUrl}
          backdrop="static"
          className="frameEmulator"
        >
          <ModalHeader toggle={this.closeClickHandle}></ModalHeader>
          <ModalBody>
            <div className="sessionActionButton">
              {/* <span>
                <img
                  id="endAppEmulationSession"
                  src={ic_call_cut}
                  className="videoIcon cursorPointer px-1 m-0"
                  title={this.props.role === USER_ROLES.AGENT ? getMessage("END_SESSION") : getMessage("LEAVE_SESSION")}
                  onClick={this.closeClickHandle}
                />
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  id="endAppEmulationSession"
                  onClick={this.closeClickHandle}
                >
                  {this.props.role === USER_ROLES.AGENT
                    ? getMessage("END_SESSION")
                    : getMessage("LEAVE_SESSION")}
                </button>
              </span> */}
            </div>
            <iframe
              className="emulatorIFrame"
              src={this.props.appEmulationUrl}
              id="iframeEmulator"
              key={1}
              title="AppEmulation"
            ></iframe>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default AppEmulationIFrame;
